// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1e6ce","tab":"Tabs_tab__1amRz","tabActive":"Tabs_tabActive___JsAy"};